import React, { useEffect, useState } from "react";
import {
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import ResultHandler from "../ResultHandler";

const DeAssignReservationModal = ({
  show,
  onCloseClick,
  onConfirm,
  error,
}) => {
  const [err, setErr] = useState(error);
  const [date, setDate] = useState(error);

  const handleClose = () => {
    onCloseClick();
    setErr(null);
  };

  const handleConfirm = () => {
    onConfirm(date);
  };

  useEffect(() => {
    if (error) {
      setErr(error);
    } else {
      setErr(null);
    }
  }, [error]);

  return (
    <Modal isOpen={show} toggle={handleClose} centered={true}>
      <ModalBody className="py-5 px-5">
        <div className="text-center">
          <i className="bx bx-error" style={{ fontSize: "9em" }} />
          <h2>Are you sure?</h2>
          <p>You won't be able to revert this!</p>
        </div>

        <FormGroup className="mt-3">
          <Label>Date</Label>
          <Input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </FormGroup>

        <ResultHandler error={err} />

        <Row>
          <Col>
            <div className="text-center mt-4">
                <button
                  type="button"
                  className="btn btn-danger btn-lg"
                  onClick={handleConfirm}
                >
                  De Assign
                </button>

              <button
                type="button"
                className="btn btn-secondary btn-lg ms-2"
                onClick={handleClose}
              >
                Cancel
              </button>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default DeAssignReservationModal;
